export default __webpack_public_path__ + "static/media/pdf.fe7a1728.svg";